"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _classnames = _interopRequireDefault(require("classnames"));

var _preactCompat = require("preact-compat");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var handleEnter = function handleEnter(e, onEnter) {
  if (e.key === 'Enter' && onEnter) {
    e.preventDefault();
    e.stopPropagation();
    onEnter();
  }
};

var handleChange = function handleChange(e, onChange) {
  if (e.target instanceof HTMLInputElement && onChange) {
    onChange(e.target.value);
  }
};

var InputGroup = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(InputGroup, _PureComponent);

  var _super = _createSuper(InputGroup);

  function InputGroup() {
    (0, _classCallCheck2.default)(this, InputGroup);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(InputGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          preIcon = _this$props.preIcon,
          postIcon = _this$props.postIcon;
      return (0, _preact.h)("div", {
        className: "form-group"
      }, (0, _preact.h)("div", {
        className: "input-wrapper"
      }, Boolean(preIcon) && (0, _preact.h)("span", {
        className: "pre-icon-wrapper input-icon-wrapper"
      }, preIcon), (0, _preact.h)(Input, this.props), Boolean(postIcon) && (0, _preact.h)("span", {
        className: "post-icon-wrapper input-icon-wrapper"
      }, postIcon)));
    }
  }]);
  return InputGroup;
}(_preactCompat.PureComponent);

var Input = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Input, _Component);

  var _super2 = _createSuper(Input);

  function Input() {
    (0, _classCallCheck2.default)(this, Input);
    return _super2.apply(this, arguments);
  }

  (0, _createClass2.default)(Input, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.attributes.value !== nextProps.attributes.value || this.props.attributes.placeholder !== nextProps.attributes.placeholder || this.props.attributes.type !== nextProps.attributes.type || this.props.postIcon !== nextProps.postIcon || this.props.onChange !== nextProps.onChange || this.props.onEnter !== nextProps.onEnter || this.props.className !== nextProps.className;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          postIcon = _this$props2.postIcon,
          onEnter = _this$props2.onEnter,
          onFocus = _this$props2.onFocus,
          onBlur = _this$props2.onBlur,
          onChange = _this$props2.onChange,
          initialValue = _this$props2.initialValue,
          disabled = _this$props2.disabled;
      return (0, _preact.h)("input", (0, _extends2.default)({
        // eslint fix for jsx-a11y/interactive-supports-focus
        role: "button",
        className: (0, _classnames.default)('input-group', className, {
          'has-post-icon': postIcon
        }),
        onKeyUp: function onKeyUp(e) {
          return handleChange(e, function (value) {
            onChange(value);
          });
        },
        onKeyDown: function onKeyDown(e) {
          return handleEnter(e, onEnter);
        },
        onFocus: onFocus,
        onBlur: onBlur,
        value: initialValue,
        disabled: disabled
      }, this.props.attributes));
    }
  }]);
  return Input;
}(_preact.Component);

var _default = InputGroup;
exports.default = _default;